export const LATEST_PRIVACY_POLICY_DIALOG_ID = "LATEST_PRIVACY_POLICY_DIALOG_ID";
